// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.adm-overflow-hidden {
    overflow: initial !important;
}

.post-container {
    display: flex;
}

.post-bottom {
    margin: 20px 0;
}

.post {
    display: flex;
    background-color: var(--vkui--color_background_secondary);
    flex-direction: column;
    border-radius: 0px 10px 10px 10px;
    width: 100%;
    min-height: 100%;
}

a.article-text {
    font-size: initial;
    color: unset;
}

.post a[href] {
    color: #2688EB;
    text-decoration: none;
}

.post img:hover {
    background: none;
    opacity: 100%;
}

.premodeAvatar img:hover {
    opacity: 1;
    cursor: default;
}

.post-article {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: none;
    padding: 14px 10px;
    margin-bottom: 16px;
    margin-top: 8px;
    border-radius: 12px;
    border: 1px var(--vkui--color_text_secondary) solid;
    align-items: flex-end;
}

.post-time {
    text-align: right;
    padding: 6px;
    color: var(--vkui--color_text_secondary);
    font-size: smaller;
    margin-top: auto;
}

.post-char {
    text-align: left;
    padding: 6px;
    color: var(--vkui--color_text_secondary);
    font-size: smaller;
    margin-top: auto;
}

.post-selected-name {
    color: var(--vkui_internal--icon_color,var(--vkui--color_icon_accent));
    padding: 4px 0px 10px 10px;
    font-weight: 800;
    font-size: 14px;
}

.post-tail {
    position: relative;
    left: 2px;
}

.post-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 12%;
}

.post-right {
    display: flex;
    position: relative;
    width: 88%;
}

.post-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.media-container {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    overflow: inherit;
}

.media-container-drag {
    display: flex;
    gap: 6px;
    padding: 4px;
    flex-direction: row;
    flex-wrap: wrap;
    background: var(--vkui--color_background_secondary--hover);
    border-radius: 6px;
    margin: 6px;
}

.tail-icon .background, .tail-icon .border_1x {
    fill: var(--vkui--color_background_secondary);
}

.media-container.media-count-1 .media-item {
    flex: 1 1 100%;
}

.media-container.media-count-2 .media-item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
}

.media-container.media-count-3 .media-item:nth-child(1) {
    flex: 1 1 100%;
}

.media-container.media-count-3 .media-item:nth-child(n+2) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
}

.media-container.media-count-4 .media-item:nth-child(1) {
    flex: 1 1 100%;
}

.media-container.media-count-4 .media-item:nth-child(n+2) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 10px);
}

.media-container.media-count-5 .media-item:nth-child(1),
.media-container.media-count-5 .media-item:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-5 .media-item:nth-child(n+3) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 2.67px);
}

.media-container.media-count-6 .media-item:nth-child(1),
.media-container.media-count-6 .media-item:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-6 .media-item:nth-child(n+3) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 3px);
}

.media-container.media-count-7 .media-item:nth-child(1),
.media-container.media-count-7 .media-item:nth-child(2),
.media-container.media-count-7 .media-item:nth-child(3) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.33% - 3px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-7 .media-item:nth-child(n+4) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 3px);
}

.media-container.media-count-8 .media-item:nth-child(1),
.media-container.media-count-8 .media-item:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-8 .media-item:nth-child(n+3) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 2.67px);
}

.media-container.media-count-9 .media-item:nth-child(1),
.media-container.media-count-9 .media-item:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-9 .media-item:nth-child(n+3) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 2.67px);
}

.media-container.media-count-10 .media-item:nth-child(1),
.media-container.media-count-10 .media-item:nth-child(2) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 2px);  /* Занимают по 50% ширины контейнера */
}

.media-container.media-count-10 .media-item:nth-child(n+3) {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 2.67px);
}

/*.media-item-drag.dragging {*/
/*    opacity: 0.3;*/
/*    z-index: 1000;*/
/*    transition: all 0.2s ease-in-out;*/
/*    -webkit-transition: all 0.2s ease-in-out;*/
/*}*/

/*.media-item-drag.notdragging {*/
/*    transition: all 0.2s ease-in-out;*/
/*    -webkit-transition: all 0.2s ease-in-out;*/
/*}*/

.media-item {
    position: relative;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1/1;
}

.media-item-drag {
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    height: 25vh;
    max-width: 33%;
    flex-grow: 0;
    flex-basis: calc(33% - 4px);
    background: var(--vkui--color_background_secondary);
    position: relative;
}

.media-item-drag img:hover {
    cursor: grab;
    opacity: .8;
}

.media-item img,
.media-item video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.media-item-drag img,
.media-item-drag video {
    width: 100%;
    height: 80%;
    object-fit: cover;
}

.remove-button {
    background: none !important;
    border-radius: 0 0 4px 4px!important;
    border: none !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
    color: var(--vkui--color_background_modal_inverse) !important;
    background-color: var(--vkui--color_background_secondary) !important;
    height: 20%!important;
}

.remove-button:hover {
    background: var(--vkui--color_accent_orange_fire) !important;
    border-radius: 0 0 4px 4px!important;
    color: #fff !important;
}

.overlayVideoPreview {
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    align-items: center;
}

.overlayVideo {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}

.overlayVideo:hover {
    background-color: rgba(0, 0, 0, 0.4);
}

.url-modal .adm-input-element {
    margin-top: 16px;
    border: 1px solid var(--vkui--color_field_border_alpha);
    border-radius: 8px;
    padding: 8px;
}

.url-modal button {
    margin-top: 16px;
}

.adm-image-viewer-image-wrapper video {
    width: 100%;
}

.adm-picker {
    --item-font-size: var(--adm-font-size-10);
    font-family: 'VK Sans Display';
}

.adm-picker-header {
    padding: 4px 8px;
}

.adm-picker-header-button:nth-of-type(1) {
    color: var(--vkui--color_accent_red);
}

.text-editor {
    color: var(--vkui--color_text_primary);
    padding: 10px;
    overflow-y: auto;
    max-height: 60vh;
    font-size: initial;
    flex: 1 1;
}

.text-editor:focus {
    outline: none;
}

.formatting-buttons {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 50%;
    justify-content: flex-end;
}

.formatting-buttons button, .left-top button {
    margin: 0;
    background-color: var(--vkui--color_background_secondary);
    color: var(--vkui--color_background_modal_inverse);
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6px;
}

.format-button.active, .edit-media.active {
    background-color: #2688EB;
    border: none;
    color: #ffffff;
}

.editMediaMode {
    display: none!important;
}

.limitWarning .vkuiBanner {
    padding: 0;
}

.limitWarning p {
    color: var(--vkui--color_background_negative);
    text-align: left;
    padding-left: 8px;
}

.lengthLimit {
    background-color: rgba(210, 52, 46, 0.2) !important;
    font-weight: var(--vkui--font_weight_accent2) !important;
    color: rgb(210, 52, 46) !important;
}

.lengthLimit .vkuiFootnote {
    color: rgba(210, 52, 46, 0.6) !important;
}

.lengthLimit svg {
    color: rgb(210, 52, 46) !important;
}

.timerAwait {
    background-color: rgba(210, 150, 46, 0.2) !important;
    font-weight: var(--vkui--font_weight_accent2) !important;
    color: rgb(210, 150, 46) !important;
}

.timerAwait .vkuiFootnote {
    color: rgba(210, 150, 46, 0.6) !important;
}

.timerAwait svg {
    color: rgb(210, 150, 46) !important;
}`, "",{"version":3,"sources":["webpack://./src/Post.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yDAAyD;IACzD,sBAAsB;IACtB,iCAAiC;IACjC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sEAAsE;IACtE,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,0DAA0D;IAC1D,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;AACjC;;AAEA;;IAEI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB,GAAG,sCAAsC;AACtE;;AAEA;IACI,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;AACnC;;AAEA;;IAEI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB,GAAG,sCAAsC;AACtE;;AAEA;IACI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;AAC7B;;AAEA;;;IAGI,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B,GAAG,sCAAsC;AACzE;;AAEA;IACI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;AAC7B;;AAEA;;IAEI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB,GAAG,sCAAsC;AACtE;;AAEA;IACI,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;AACnC;;AAEA;;IAEI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB,GAAG,sCAAsC;AACtE;;AAEA;IACI,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;AACnC;;AAEA;;IAEI,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB,GAAG,sCAAsC;AACtE;;AAEA;IACI,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;AACnC;;AAEA,8BAA8B;AAC9B,oBAAoB;AACpB,qBAAqB;AACrB,wCAAwC;AACxC,gDAAgD;AAChD,IAAI;;AAEJ,iCAAiC;AACjC,wCAAwC;AACxC,gDAAgD;AAChD,IAAI;;AAEJ;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,2BAA2B;IAC3B,mDAAmD;IACnD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,6DAA6D;IAC7D,oEAAoE;IACpE,qBAAqB;AACzB;;AAEA;IACI,4DAA4D;IAC5D,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,uDAAuD;IACvD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,yDAAyD;IACzD,kDAAkD;IAClD,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;IACnD,wDAAwD;IACxD,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oDAAoD;IACpD,wDAAwD;IACxD,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["body.adm-overflow-hidden {\r\n    overflow: initial !important;\r\n}\r\n\r\n.post-container {\r\n    display: flex;\r\n}\r\n\r\n.post-bottom {\r\n    margin: 20px 0;\r\n}\r\n\r\n.post {\r\n    display: flex;\r\n    background-color: var(--vkui--color_background_secondary);\r\n    flex-direction: column;\r\n    border-radius: 0px 10px 10px 10px;\r\n    width: 100%;\r\n    min-height: 100%;\r\n}\r\n\r\na.article-text {\r\n    font-size: initial;\r\n    color: unset;\r\n}\r\n\r\n.post a[href] {\r\n    color: #2688EB;\r\n    text-decoration: none;\r\n}\r\n\r\n.post img:hover {\r\n    background: none;\r\n    opacity: 100%;\r\n}\r\n\r\n.premodeAvatar img:hover {\r\n    opacity: 1;\r\n    cursor: default;\r\n}\r\n\r\n.post-article {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    background: none;\r\n    padding: 14px 10px;\r\n    margin-bottom: 16px;\r\n    margin-top: 8px;\r\n    border-radius: 12px;\r\n    border: 1px var(--vkui--color_text_secondary) solid;\r\n    align-items: flex-end;\r\n}\r\n\r\n.post-time {\r\n    text-align: right;\r\n    padding: 6px;\r\n    color: var(--vkui--color_text_secondary);\r\n    font-size: smaller;\r\n    margin-top: auto;\r\n}\r\n\r\n.post-char {\r\n    text-align: left;\r\n    padding: 6px;\r\n    color: var(--vkui--color_text_secondary);\r\n    font-size: smaller;\r\n    margin-top: auto;\r\n}\r\n\r\n.post-selected-name {\r\n    color: var(--vkui_internal--icon_color,var(--vkui--color_icon_accent));\r\n    padding: 4px 0px 10px 10px;\r\n    font-weight: 800;\r\n    font-size: 14px;\r\n}\r\n\r\n.post-tail {\r\n    position: relative;\r\n    left: 2px;\r\n}\r\n\r\n.post-left {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    width: 12%;\r\n}\r\n\r\n.post-right {\r\n    display: flex;\r\n    position: relative;\r\n    width: 88%;\r\n}\r\n\r\n.post-footer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.media-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 4px;\r\n    overflow: inherit;\r\n}\r\n\r\n.media-container-drag {\r\n    display: flex;\r\n    gap: 6px;\r\n    padding: 4px;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    background: var(--vkui--color_background_secondary--hover);\r\n    border-radius: 6px;\r\n    margin: 6px;\r\n}\r\n\r\n.tail-icon .background, .tail-icon .border_1x {\r\n    fill: var(--vkui--color_background_secondary);\r\n}\r\n\r\n.media-container.media-count-1 .media-item {\r\n    flex: 1 1 100%;\r\n}\r\n\r\n.media-container.media-count-2 .media-item {\r\n    flex: 1 1 calc(50% - 10px);\r\n}\r\n\r\n.media-container.media-count-3 .media-item:nth-child(1) {\r\n    flex: 1 1 100%;\r\n}\r\n\r\n.media-container.media-count-3 .media-item:nth-child(n+2) {\r\n    flex: 1 1 calc(50% - 10px);\r\n}\r\n\r\n.media-container.media-count-4 .media-item:nth-child(1) {\r\n    flex: 1 1 100%;\r\n}\r\n\r\n.media-container.media-count-4 .media-item:nth-child(n+2) {\r\n    flex: 1 1 calc(33.33% - 10px);\r\n}\r\n\r\n.media-container.media-count-5 .media-item:nth-child(1),\r\n.media-container.media-count-5 .media-item:nth-child(2) {\r\n    flex: 0 0 calc(50% - 2px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-5 .media-item:nth-child(n+3) {\r\n    flex: 1 1 calc(33.33% - 2.67px);\r\n}\r\n\r\n.media-container.media-count-6 .media-item:nth-child(1),\r\n.media-container.media-count-6 .media-item:nth-child(2) {\r\n    flex: 0 0 calc(50% - 2px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-6 .media-item:nth-child(n+3) {\r\n    flex: 1 1 calc(25% - 3px);\r\n}\r\n\r\n.media-container.media-count-7 .media-item:nth-child(1),\r\n.media-container.media-count-7 .media-item:nth-child(2),\r\n.media-container.media-count-7 .media-item:nth-child(3) {\r\n    flex: 0 0 calc(33.33% - 3px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-7 .media-item:nth-child(n+4) {\r\n    flex: 1 1 calc(50% - 3px);\r\n}\r\n\r\n.media-container.media-count-8 .media-item:nth-child(1),\r\n.media-container.media-count-8 .media-item:nth-child(2) {\r\n    flex: 0 0 calc(50% - 2px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-8 .media-item:nth-child(n+3) {\r\n    flex: 1 1 calc(33.33% - 2.67px);\r\n}\r\n\r\n.media-container.media-count-9 .media-item:nth-child(1),\r\n.media-container.media-count-9 .media-item:nth-child(2) {\r\n    flex: 0 0 calc(50% - 2px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-9 .media-item:nth-child(n+3) {\r\n    flex: 1 1 calc(33.33% - 2.67px);\r\n}\r\n\r\n.media-container.media-count-10 .media-item:nth-child(1),\r\n.media-container.media-count-10 .media-item:nth-child(2) {\r\n    flex: 0 0 calc(50% - 2px);  /* Занимают по 50% ширины контейнера */\r\n}\r\n\r\n.media-container.media-count-10 .media-item:nth-child(n+3) {\r\n    flex: 1 1 calc(33.33% - 2.67px);\r\n}\r\n\r\n/*.media-item-drag.dragging {*/\r\n/*    opacity: 0.3;*/\r\n/*    z-index: 1000;*/\r\n/*    transition: all 0.2s ease-in-out;*/\r\n/*    -webkit-transition: all 0.2s ease-in-out;*/\r\n/*}*/\r\n\r\n/*.media-item-drag.notdragging {*/\r\n/*    transition: all 0.2s ease-in-out;*/\r\n/*    -webkit-transition: all 0.2s ease-in-out;*/\r\n/*}*/\r\n\r\n.media-item {\r\n    position: relative;\r\n    background-color: #f0f0f0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    aspect-ratio: 1/1;\r\n}\r\n\r\n.media-item-drag {\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 25vh;\r\n    max-width: 33%;\r\n    flex-grow: 0;\r\n    flex-basis: calc(33% - 4px);\r\n    background: var(--vkui--color_background_secondary);\r\n    position: relative;\r\n}\r\n\r\n.media-item-drag img:hover {\r\n    cursor: grab;\r\n    opacity: .8;\r\n}\r\n\r\n.media-item img,\r\n.media-item video {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.media-item-drag img,\r\n.media-item-drag video {\r\n    width: 100%;\r\n    height: 80%;\r\n    object-fit: cover;\r\n}\r\n\r\n.remove-button {\r\n    background: none !important;\r\n    border-radius: 0 0 4px 4px!important;\r\n    border: none !important;\r\n    display: flex !important;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--vkui--color_background_modal_inverse) !important;\r\n    background-color: var(--vkui--color_background_secondary) !important;\r\n    height: 20%!important;\r\n}\r\n\r\n.remove-button:hover {\r\n    background: var(--vkui--color_accent_orange_fire) !important;\r\n    border-radius: 0 0 4px 4px!important;\r\n    color: #fff !important;\r\n}\r\n\r\n.overlayVideoPreview {\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    display: flex;\r\n    justify-content: center;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    align-items: center;\r\n}\r\n\r\n.overlayVideo {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.overlayVideo:hover {\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.url-modal .adm-input-element {\r\n    margin-top: 16px;\r\n    border: 1px solid var(--vkui--color_field_border_alpha);\r\n    border-radius: 8px;\r\n    padding: 8px;\r\n}\r\n\r\n.url-modal button {\r\n    margin-top: 16px;\r\n}\r\n\r\n.adm-image-viewer-image-wrapper video {\r\n    width: 100%;\r\n}\r\n\r\n.adm-picker {\r\n    --item-font-size: var(--adm-font-size-10);\r\n    font-family: 'VK Sans Display';\r\n}\r\n\r\n.adm-picker-header {\r\n    padding: 4px 8px;\r\n}\r\n\r\n.adm-picker-header-button:nth-of-type(1) {\r\n    color: var(--vkui--color_accent_red);\r\n}\r\n\r\n.text-editor {\r\n    color: var(--vkui--color_text_primary);\r\n    padding: 10px;\r\n    overflow-y: auto;\r\n    max-height: 60vh;\r\n    font-size: initial;\r\n    flex: 1;\r\n}\r\n\r\n.text-editor:focus {\r\n    outline: none;\r\n}\r\n\r\n.formatting-buttons {\r\n    padding-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    min-height: 50%;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.formatting-buttons button, .left-top button {\r\n    margin: 0;\r\n    background-color: var(--vkui--color_background_secondary);\r\n    color: var(--vkui--color_background_modal_inverse);\r\n    width: 100%;\r\n    height: auto;\r\n    aspect-ratio: 1 / 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 6px;\r\n}\r\n\r\n.format-button.active, .edit-media.active {\r\n    background-color: #2688EB;\r\n    border: none;\r\n    color: #ffffff;\r\n}\r\n\r\n.editMediaMode {\r\n    display: none!important;\r\n}\r\n\r\n.limitWarning .vkuiBanner {\r\n    padding: 0;\r\n}\r\n\r\n.limitWarning p {\r\n    color: var(--vkui--color_background_negative);\r\n    text-align: left;\r\n    padding-left: 8px;\r\n}\r\n\r\n.lengthLimit {\r\n    background-color: rgba(210, 52, 46, 0.2) !important;\r\n    font-weight: var(--vkui--font_weight_accent2) !important;\r\n    color: rgb(210, 52, 46) !important;\r\n}\r\n\r\n.lengthLimit .vkuiFootnote {\r\n    color: rgba(210, 52, 46, 0.6) !important;\r\n}\r\n\r\n.lengthLimit svg {\r\n    color: rgb(210, 52, 46) !important;\r\n}\r\n\r\n.timerAwait {\r\n    background-color: rgba(210, 150, 46, 0.2) !important;\r\n    font-weight: var(--vkui--font_weight_accent2) !important;\r\n    color: rgb(210, 150, 46) !important;\r\n}\r\n\r\n.timerAwait .vkuiFootnote {\r\n    color: rgba(210, 150, 46, 0.6) !important;\r\n}\r\n\r\n.timerAwait svg {\r\n    color: rgb(210, 150, 46) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
